import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { SatisfactionMapContext } from "../../../contexts/SatisfactionMapFilterContext"; 
import DropdownIcon from "../../DropdownIcon";
import { useContext } from "react";
import { classes } from "../classes";

export default function Evaluation() {

    const {
        evaluation, setEvaluation,
    } = useContext(SatisfactionMapContext); 

    return (
        <>
            <Typography style={classes.labelInput}>
                Notas de Satisfação:
            </Typography>

            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={evaluation}
                    onChange={(e) => { setEvaluation(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value={"1"}>Muito Insatisfeito</MenuItem>
                    <MenuItem value={"2"}>Insatisfeito</MenuItem>
                    <MenuItem value={"3"}>Neutro</MenuItem>
                    <MenuItem value={"4"}>Satisfeito</MenuItem>
                    <MenuItem value={"5"}>Muito Satisfeito</MenuItem>
                </Select>
            </FormControl>
        </>
    )
}